/**
 * Delete a cookie by name
 * @param name name of cookie
 * @param domain optional domain of cookie, necessary for subdomains
 * @param _document Internal parameter for Dependency Injection [DO NOT USE] -
 * document object
 */
export const deleteCookie = ({ name, domain, _document = document, }) => {
    _document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;${domain !== undefined ? ` domain=${domain};` : ''}`;
};
/**
 * Constructs the appropriate subdomain string for use with cookie domains
 * @param _window Internal parameter for Dependency Injection [DO NOT USE] -
 * window object
 * @returns {string} A string representing the subdomain for use with cookie domains
 */
export const getCookieSubdomainString = (
/* istanbul ignore next */
_window = window) => `.${_window.location.hostname.split('.').slice(-2).join('.')}`;
